import type { LeadFunnelSettings } from './types';

export const DEFAULT_LEAD_FUNNEL_SETTINGS: LeadFunnelSettings = { scope: 'mine', leadTypeId: null };

export function decodeLeadFunnelSettings(value: unknown): LeadFunnelSettings {
  if (!value || typeof value !== 'object') return DEFAULT_LEAD_FUNNEL_SETTINGS;
  return {
    scope:
      'scope' in value &&
      (value.scope === 'mine' || value.scope === 'branch' || value.scope === 'all')
        ? value.scope
        : 'mine',
    leadTypeId:
      'leadTypeId' in value &&
      typeof value.leadTypeId === 'number' &&
      Number.isSafeInteger(value.leadTypeId) &&
      value.leadTypeId > 0
        ? value.leadTypeId
        : null,
  };
}

/** На границе RPC отбрасываем неизвестные поля, неверные известные — отклоняем. */
export function validateLeadFunnelSettings(settings: LeadFunnelSettings): LeadFunnelSettings {
  if (
    !settings ||
    !['mine', 'branch', 'all'].includes(settings.scope) ||
    (settings.leadTypeId !== null &&
      (!Number.isSafeInteger(settings.leadTypeId) || settings.leadTypeId <= 0))
  ) {
    throw new Error('Некорректные настройки воронки');
  }
  return { scope: settings.scope, leadTypeId: settings.leadTypeId };
}
